// Dependencies
require("webstrap/scaffolding");

// Styles
require("./responsive-embed.scss");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/webstrap/responsive-embed/index.js
 ** module id = 192
 ** module chunks = 0 1
 **/